// export const GET_CAR_REQUEST = "GET_CAR_REQUEST";
// export const GET_CAR_FAILURE = "GET_CAR_FAILURE";
export const GET_CAR = "GET_CAR";
